<template>
  <div>
    <canvas :id="chartId" ></canvas>
  </div>
</template>

<script src="./Chart.js" />
<style scoped src="./Chart.scss" lang="scss" />